/// <reference path="../../app.d.ts"/>
/// <reference path="../../../../typings/jquery.d.ts"/>

import { VesDamageViewService } from "../../../../../shared/services/VesDamageViewService";
import { DamageFormModel } from '../models/DamageFormModel';
import { CheckForm } from '../../../../../shared/models/view/DamageCheckForm';
import { PersonalDataFormModel } from '../models/PersonalDataFormModel';
import { DocumentsBillsFormModel } from '../models/DocumentsBillsFormModel';
import { DamageCostLimit } from "../../../../../shared/models/view/DamageCostLimit.enum";

export class AppViewService extends VesDamageViewService {

	private readonly damageTypeName: string;

	private readonly countrySelectId: string;
	private readonly personName: string;
	private readonly personPrenameId: string;
	private readonly personLastnameId: string;
	private readonly registeredPersonName: string;
	private readonly personNameContainerClass: string;
	private readonly registeresPersonContainerClass: string;
	private readonly illnessDescriptionId: string;
	private readonly illnessDateId: string;
	private readonly illnessLocationId: string;
	private readonly illnessDepartureDateId: string;
	private readonly illnessTherapyName: string;
	private readonly uploadTreatmentId: string;
	private readonly uploadMedicationsId: string;
	private readonly uploadPatientTransportId: string;
	private readonly uploadMiscId: string;
	private readonly proofDepatureClass: string;
	private readonly sumChangeClass: string;
	private readonly ibanName: string;
	private readonly schadenTyp: string;


	constructor(parent: StepController, options: DamageDeclarationOhcOptions, loader: BasicLoader<DamageDeclarationOhcAppDefinition>) {
		super(parent, options, loader);
		this.formId = this.options.app.applicationId || "damagedeclarationohc";
		this.countrySelectId = '#illnesslocation-select';
		this.personName = '[name="BetroffenePerson"]';
		this.damageTypeName = '[name="SchadenTyp"]';
		this.personPrenameId = '#prename-pers';
		this.personLastnameId = '#lastname-pers';
		this.registeredPersonName = '[name="BetroffenePersonGemeldet"]';
		this.personNameContainerClass = '.js-pers-name';
		this.registeresPersonContainerClass = '.js-registered';

		this.illnessDescriptionId = '#illness-desc';
		this.illnessDateId = '#illnessdate';
		this.illnessLocationId = '#illnesslocation-select';
		this.illnessDepartureDateId = '#illness-dep-date';
		this.illnessTherapyName = '[name="Behandlung"]';

		this.uploadCostType1Id = '#UploadCostTypetreatment';
		this.uploadCostType2Id = '#UploadCostTypemedications';
		this.uploadCostType3Id = '#UploadCostTypepatientTransport';
		this.uploadCostType4Id = '#UploadCostTypemisc';

		this.uploadTreatmentId = '#UploadCostTypetreatment';
		this.uploadMedicationsId = '#UploadCostTypemedications';
		this.uploadPatientTransportId = '#UploadCostTypepatientTransport';
		this.uploadMiscId = '#UploadCostTypemisc';

		this.proofDepatureClass = '.js-proofdepature';
		this.sumChangeClass = '.js-sum-change';

		this.ibanName = 'input[name="Iban"]';
		this.schadenTyp = '[name="SchadenTyp"]';
	}


	/**
	 *  Add listeners for the damage page
	 */
	public addDamageListeners(personChangeListener: JQuery.EventHandler<HTMLElement>, damageTypeChangeListenere: JQuery.EventHandler<HTMLElement>, changeListener: JQuery.EventHandler<HTMLElement>, submitListener: JQuery.EventHandler<HTMLElement>, removeDependedErrorsOnSchadentypChange: JQuery.EventHandler<HTMLElement>): void {
		const $form = this.getForm();
		$form.find(this.personName).on("change", personChangeListener);
		$form.find(this.ownDescriptionTextarea).on('change', changeListener);
		$form.find(this.damageTypeName).on('change', damageTypeChangeListenere);
		$form.find(this.schadenTyp).on('change', removeDependedErrorsOnSchadentypChange);
		this.addListeners(changeListener, submitListener);
	}

	/**
	 *  Add listeners for the document bills page
	 */
	public addDocumentBillsListeners(sumChangeListener: JQuery.EventHandler<HTMLElement>, costTypeChangeListener: JQuery.EventHandler<HTMLElement>, changeListener: JQuery.EventHandler<HTMLElement>, submitListener: JQuery.EventHandler<HTMLElement>): void {
		const $form = this.getForm();
		$form.find(this.costType).on("click", costTypeChangeListener);
		$form.find(this.sumChangeClass).on("change", sumChangeListener);
		this.addListeners(changeListener, submitListener);
	}

	/**
	 * Add listeners for the personal data page
	 */
	public addPersonalDataListeners(
		ibanChangeListener: JQuery.EventHandler<HTMLElement>,
		abweichenderKontoinhaberChangeListener: JQuery.EventHandler<HTMLElement>,
		changeListener: JQuery.EventHandler<HTMLElement>,
		submitListener: JQuery.EventHandler<HTMLElement>,
		checkCountryCodeIban: JQuery.EventHandler<HTMLElement>,
		changeBic: JQuery.EventHandler<HTMLElement>): void {
		const $form = this.getForm();
		$form.find(this.ibanName).on('blur', ibanChangeListener);
		if (this.options.app.countrycodeswithsepasupport
			&& this.options.app.countrycodeswithsepasupport.length > 0) {
			$form.find(this.ibanName).on('change', checkCountryCodeIban);
			$form.find(this.ibanName).on('input', checkCountryCodeIban);
			$form.find('[name="Bic"]').on('change', changeBic);
		}
		$form.find(this.abweichenderKontoInhaberName).on('change', abweichenderKontoinhaberChangeListener);
		$form.find(this.vornameName).on('change', abweichenderKontoinhaberChangeListener);
		$form.find(this.nachnameName).on('change', abweichenderKontoinhaberChangeListener);
		this.addListeners(changeListener, submitListener);
	}

	/**
	 * returns the form
	 */
	public getForm(): JQuery<HTMLFormElement> {
		return this.$ctx.find(`#${this.formId} form.js-main-form`);
	}

	/**
	 * returns the DamageOhcFormModel
	 */
	public getFormModelFromDamageView(): DamageFormModel {
		const formData = this.getFormData();

		const formModel = new DamageFormModel();
		formModel.SchadenTyp = formData.SchadenTyp;
		formModel.BetroffenePerson = formData.BetroffenePerson;
		formModel.BetroffenePersonVorname = formData.BetroffenePersonVorname;
		formModel.BetroffenePersonNachname = formData.BetroffenePersonNachname;
		formModel.BetroffenePersonGemeldet = formData.BetroffenePersonGemeldet;
		formModel.BetroffenePersonGeburtsdatum = formData.BetroffenePersonGeburtsdatum;
		formModel.EigeneAngabenBeschreibung = this.getEigeneAngabenBeschreibungFromView();
		formModel.SchadenStartDatum = formData.SchadenStartDatum;
		formModel.AbreiseDatum = formData.AbreiseDatum;
		formModel.SchadenLand = formData.SchadenLand;
		formModel.SchadenLandName = this.getCountryNameFromView(this.countrySelectId);
		formModel.Behandlung = formData.Behandlung;

		return formModel;
	}

	/**
	 * returns the DocumentsBillsFormModel
	 */
	public getFormModelFromDocumentsBillsDataView(): DocumentsBillsFormModel {
		const formData = this.getFormData();

		const documentsBillsModel = new DocumentsBillsFormModel();
		documentsBillsModel.Kostenart = formData.Kostenart;
		documentsBillsModel.BehandlungskostenBelege = this.getCostTypeDocumentsFromView(this.uploadTreatmentId);
		documentsBillsModel.MedikamenteBelege = this.getCostTypeDocumentsFromView(this.uploadMedicationsId);
		documentsBillsModel.PatiententransportBelege = this.getCostTypeDocumentsFromView(this.uploadPatientTransportId);
		documentsBillsModel.SonstigeBelege = this.getCostTypeDocumentsFromView(this.uploadMiscId);
		documentsBillsModel.KostenSummen = this.getCostsSummary();
		documentsBillsModel.KostenAngaben = formData.KostenAngaben;

		return documentsBillsModel;
	}

	/**
	 * returns the PersonalDataOhcFormModel data
	 */
	public getFormModelFromPersonalDataView(): PersonalDataFormModel {
		const formData = this.getFormData();
		const personalDataModel = new PersonalDataFormModel({
			Iban: formData.Iban,
			Bic: formData.Bic,
			Kontoinhaber: formData.Kontoinhaber,
			AbweichenderKontoInhaber: formData.AbweichenderKontoInhaber === 'true',
			VersicherungKrankenschutzGesellschaft: formData.VersicherungKrankenschutzGesellschaft,
			VersicherungKrankenschutzVersicherungnummer: formData.VersicherungKrankenschutzVersicherungnummer,
			VersicherungReiseschtuz: formData.VersicherungReiseschtuz,
			VersicherungReiseschutzAnschrift: formData.VersicherungReiseschutzAnschrift,
			VersicherungReiseschutzBankname: formData.VersicherungReiseschutzBankname,
			VersicherungReiseschutzGesellschaft: formData.VersicherungReiseschutzGesellschaft,
			VersicherungReiseschutzKreditkartengesellschaft: formData.VersicherungReiseschutzKreditkartengesellschaft,
			VersicherungReiseschutzKreditkartennummer: formData.VersicherungReiseschutzKreditkartennummer,
			VersicherungReiseschutzVersicherungsnummer: formData.VersicherungReiseschutzVersicherungsnummer,
			VersicherungUnfallschutz: formData.VersicherungUnfallschutz,
			VersicherungUnfallschutzAnschrift: formData.VersicherungUnfallschutzAnschrift,
			VersicherungUnfallschutzGesellschaft: formData.VersicherungUnfallschutzGesellschaft,
			VersicherungUnfallschutzVersicherungsnummer: formData.VersicherungUnfallschutzVersicherungsnummer,
		});
		personalDataModel.PersoenlicheDaten = this._getPersonalDataModel(formData);
		personalDataModel.PersoenlicheDaten.Adresse.Postleitzahl = formData.Plz;
		personalDataModel.PersoenlicheDaten.Mitgliedsnummer = formData.Mitgliedsnummer;

		return personalDataModel;
	}

	/**
	 *  retuns the CheckOhcFormModel
	 */
	public getFormModelFromCheckDataView(): CheckForm {
		const formData = this.getFormData();

		const checkModel = new CheckForm();
		checkModel.TimeStamp = formData.TimeStamp;
		const lightboxcontent = $(this.lightboxClass).clone().get();
		checkModel.LightboxContent = this.retrieveLightboxContent(lightboxcontent, false);

		return checkModel;
	}

	/**
	 * resets the person fields
	 */
	public clearPersonFields(): void {
		const $form = this.getForm();
		$form.find(this.personPrenameId).parent().find('.js-clear-button').trigger('click');
		$form.find(this.personLastnameId).parent().find('.js-clear-button').trigger('click');
		$form.find(this.registeredPersonName).prop('checked', false);
	}

	/**
	 * triggers change of the person input fields
	 */
	public triggerPersonFieldsChange(): void {
		const $form = this.getForm();
		$form.find(this.personPrenameId).trigger('change');
		$form.find(this.personLastnameId).trigger('change');
	}

	/**
	 * resets the fields which are dependend on the damagetyp
	 */
	public clearFieldsDependOnDamageTyp(): void {
		const $form = this.getForm();
		$form.find(this.personNameContainerClass).toggleClass('h-hidden', true);
		$form.find(this.registeresPersonContainerClass).toggleClass('h-hidden', true);
		this.clearPersonFields();
		$form.find(this.personName).prop('checked', false);
		$form.find(this.illnessDescriptionId).val('');
		$form.find(this.illnessDateId).val('');
		$form.find(`${this.illnessLocationId}option`).first().attr('selected');
		$form.find(this.illnessDepartureDateId).val('');
		$form.find(this.illnessTherapyName).prop('checked', false);
	}

	public hideOrShowProofDepatureSection(costLimit: DamageCostLimit): void {
		if (costLimit !== DamageCostLimit.Ok) {
			this.$ctx.find(this.proofDepatureClass).toggleClass('h-hidden', false);
		} else {
			this.$ctx.find(this.proofDepatureClass).toggleClass('h-hidden', true);
		}
	}
}
